<template>
    <div class="image-card">
        <div class="card">

            <slot name="header">
                <div class="card-header" v-html="header"></div>
            </slot>

            <div class="card-body d-flex flex-column">

                <slot name="body">

                    <div class="text-center mb-5">
                        <img :src="image" alt="graph" class="w-full">
                    </div>

                    <ul v-if="items.length" class="list-none p-0 m-0">
                        <li v-for="(item, iindex) in items" :key="iindex" class="mb-4 d-flex align-content-center justify-content-start">
                            <div
                                class="p-avatar p-component p-avatar-circle p-avatar-lg fw-bold"
                                :style="
                                    `background-color: rgba(${item.iconColor}, 0.1);
                                    color: rgb(${item.iconColor});
                                    border: 1px solid rgb(${item.iconColor});`
                                "
                            >
                                <template v-if="item.image && item.image != ''">
                                    <img :src="item.image" />
                                </template>
                                <template v-else-if="item.icon && item.icon != ''">
                                    <i :class="item.icon"></i>
                                </template>
                                <template v-else>{{ item.title[0] }}{{ item.title.split(' ')[1][0] }}</template>
                            </div>
                            <div class="ms-3">
                                <span class="d-block">{{ item.title }}</span>
                                <p><a href="#" class="cursor-pointer d-block fw-bold" :class="item.linkClass">{{ item.subtitle }}</a></p>
                            </div>
                        </li>
                    </ul>

                </slot>

            </div>

            <slot name="footer">
                <div class="card-footer" v-html="footer"></div>
            </slot>

        </div>
    </div>
</template>


<script>
    export default {
        name: "ImageCard",
        props: {
            header: {
                type: String,
                default: "",
            },
            image: {
                type: String,
                default: "",
            },
            items: {
                type: Array,
                default: () => {
                    return [];
                },
            },
            footer: {
                type: String,
                default: "",
            },
        },
        setup() {
            return {};
        },
    };
</script>


<style lang="scss">
    .image-card {
        width: 100%;
        height: 100%;

        a{
            text-decoration: underline;
        }

        .list-none{
            list-style: none;
        }

        .card {
            border: 0px;
            border-radius: 10px;
            padding: 10px;
            height: 100%;
            width: 100%;
        }
        .card-header {
            background-color: unset;
            border: 0px;
            font-size: 1rem;
            font-weight: 600;
        }
        .card-footer {
            background-color: unset;
            border: 0px;
        }
    }
</style>